import { buildModelManager } from "../builder.js";
const DefaultRoomOfRequirementSelection = {
  __typename: true,
  id: true,
  archivedAt: true,
  archivedById: true,
  archivedCode: { markdown: true, truncatedHTML: true },
  createdAt: true,
  fileType: true,
  notes: { markdown: true, truncatedHTML: true },
  originalFileName: true,
  originalPath: true,
  reason: true,
  updatedAt: true
};
const modelApiIdentifier = "roomOfRequirement";
const pluralModelApiIdentifier = "roomOfRequirements";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultRoomOfRequirementSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultRoomOfRequirementSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultRoomOfRequirementSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultRoomOfRequirementSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultRoomOfRequirementSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultRoomOfRequirementSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultRoomOfRequirementSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createRoomOfRequirement",
    operationReturnType: "CreateRoomOfRequirement",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      roomOfRequirement: { required: false, type: "CreateRoomOfRequirementInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultRoomOfRequirementSelection
  },
  {
    type: "action",
    operationName: "bulkCreateRoomOfRequirements",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateRoomOfRequirementsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultRoomOfRequirementSelection
  },
  {
    type: "action",
    operationName: "updateRoomOfRequirement",
    operationReturnType: "UpdateRoomOfRequirement",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      roomOfRequirement: { required: false, type: "UpdateRoomOfRequirementInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultRoomOfRequirementSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateRoomOfRequirements",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateRoomOfRequirementsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultRoomOfRequirementSelection
  },
  {
    type: "action",
    operationName: "deleteRoomOfRequirement",
    operationReturnType: "DeleteRoomOfRequirement",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteRoomOfRequirements",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertRoomOfRequirement",
    operationReturnType: "UpsertRoomOfRequirement",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      roomOfRequirement: { required: false, type: "UpsertRoomOfRequirementInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateRoomOfRequirementResult": { hasReturnType: false },
      "... on UpdateRoomOfRequirementResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultRoomOfRequirementSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertRoomOfRequirements",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertRoomOfRequirementsInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultRoomOfRequirementSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "roomOfRequirementGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const RoomOfRequirementManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultRoomOfRequirementSelection,
  operations
);
export {
  DefaultRoomOfRequirementSelection,
  RoomOfRequirementManager
};
//# sourceMappingURL=RoomOfRequirement.js.map
